import React from "react";
import Frame43 from "../Frame43";
import "./FAQ1False.css";

function FAQ1False(props) {
  const { className, frame43Props } = props;

  return (
    <div className={`faq1 ${className || ""}`}>
      <Frame43 line36={frame43Props.line36} className={frame43Props.className} />
    </div>
  );
}

export default FAQ1False;
